import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Divider,
  Container,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import RestoreIcon from '@mui/icons-material/Restore';
import { jwtDecode } from 'jwt-decode';
import { useLocation, useParams } from 'react-router-dom';
import axiosInstance from '../services/axiosInterceptors';
import apiEndPointsConfig from '../services/apiEndPoints';

const OverViewPrompt = () => {

  const { companyId, processType } = useParams();
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";
  const [promptData, setPromptData] = useState({})
  const [messages, setMessages] = useState(promptData);
  const [loading, setLoading] = useState(true);
  const location = useLocation();



  console.log(companyId, "companyId", processType, "processType");

  const payload = {
    companyId,
    processType,
    promptType: "overallAnalysisPrompt"
  }

  const fetchClientPromptData = async (data) => {
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.clinetPromptData,
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessages(res?.data?.data[0]?.overallAnalysisPrompt?.systemPrompts
      );
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode === 401) {
        localStorage.clear();
      } else {
        console.error("Error while fetching dashboard details :", error);
      }
    }
  };

  const updateClientPromptData = async (data) => {
    try {
      const updatePayload = {
        companyId,
        processType,
        overallAnalysisPrompt: messages
      };
      const res = await axiosInstance.patch(
        apiEndPointsConfig?.updateClientPrompt,
        updatePayload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchClientPromptData(payload)
    } catch (error) {
      console.error("Update failed", error);
    }
  };

  const ProcessPayload = {
    companyId,
    process: processType
  }

  const fetchProcessPromptData = async (data) => {
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.processPromptData,
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessages(res?.data?.data[0]?.overallAnalysisPrompt?.systemPrompts
      );
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode === 401) {
        localStorage.clear();
      } else {
        console.error("Error while fetching dashboard details :", error);
      }
    }
  };

  useEffect(() => {
    if (location.state?.from === "/super-admin/process-management") {
      fetchProcessPromptData(ProcessPayload)
    } else {
      fetchClientPromptData(payload);
    }

  }, []);

  // useEffect(() => {
  //   fetchClientPromptData(payload);
  // }, []);


  const [editingMessage, setEditingMessage] = useState(null);
  const [tempValue, setTempValue] = useState('');
  const [expanded, setExpanded] = useState('m1');


  const messageTitles = {
    m1: "System Role Definition",
    m2: "Transcript Understanding",
    m3: "Entity Categories",
    m4: "Extraction Logic",
    m5: "Output Format",
    m6: "JSON Format Specification",
    m7: "Output Constraints"
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleEdit = (messageKey) => {
    setEditingMessage(messageKey);
    setTempValue(messages[messageKey]);
  };

  const handleSave = (messageKey) => {
    setMessages({ ...messages, [messageKey]: tempValue });
    setEditingMessage(null);
    setTempValue('');
  };

  const handleCancel = () => {
    setEditingMessage(null);
    setTempValue('');
  };

  const handleReset = (messageKey) => {
    setMessages({ ...messages, [messageKey]: messages[messageKey] });
    setEditingMessage(null);
    setTempValue('');
  };

  const handleResetAll = () => {
    setMessages(messages);
    setEditingMessage(null);
    setTempValue('');
  };

  const handleSaveAll = () => {
    updateClientPromptData()
  };

  const getMessageNumber = (key) => key.replace('m', '');

  return (
    <Box sx={{ backgroundColor: '#f5f7fa', minHeight: '100vh', p: 4 }}>
      <Box >
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            backgroundColor: 'white',
            borderRadius: 3,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="h5" fontWeight="bold" sx={{ mb: 0.5, color: "#7626dc" }}>
                Prompt Configuration
              </Typography>
              <Typography variant="body2">
                Configure and customize AI prompt messages for overview extraction
              </Typography>
            </Box>
            <Stack direction="row" spacing={2}>
              <Button
                startIcon={<RestoreIcon />}
                onClick={handleResetAll}
                variant="outlined"
                sx={{ textTransform: 'none' }}
              >
                Reset All
              </Button>
              <Button
                variant="contained"
                onClick={handleSaveAll}
                sx={{
                  textTransform: 'none',
                  backgroundColor: '#7626dc',
                  '&:hover': { backgroundColor: '#0288d1' },
                  px: 3,
                }}
              >
                Save All Changes
              </Button>
            </Stack>
          </Box>
        </Paper>

        {/* Messages Section */}
        <Stack spacing={2}>
          {Object.entries(messages).map(([key, value]) => (
            <Accordion
              key={key}
              expanded={expanded === key}
              onChange={handleAccordionChange(key)}
              sx={{
                backgroundColor: 'white',
                '&:before': { display: 'none' },
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                borderRadius: '8px !important',
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  '&:hover': { backgroundColor: '#f8f9fa' },
                  borderRadius: 2,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%', pr: 2 }}>
                  <Chip
                    label={`M${getMessageNumber(key)}`}
                    size="small"
                    sx={{
                      backgroundColor: '#7626dc',
                      color: 'white',
                      fontWeight: 'bold',
                      minWidth: 45,
                    }}
                  />
                  <Typography fontWeight={600} sx={{ flexGrow: 1 }}>
                    {messageTitles[key]}
                  </Typography>
                  {messages[key] !== messages[key] && (
                    <Chip
                      label="Modified"
                      size="small"
                      color="warning"
                      sx={{ fontSize: '0.7rem' }}
                    />
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Divider sx={{ mb: 2 }} />
                {editingMessage === key ? (
                  <Box>
                    <TextField
                      fullWidth
                      multiline
                      minRows={4}
                      maxRows={12}
                      value={tempValue}
                      onChange={(e) => setTempValue(e.target.value)}
                      variant="outlined"
                      sx={{
                        mb: 2,
                        '& .MuiOutlinedInput-root': {
                          fontFamily: 'monospace',
                          fontSize: '0.9rem',
                        },
                      }}
                    />
                    <Stack direction="row" spacing={1}>
                      <Button
                        startIcon={<SaveIcon />}
                        variant="contained"
                        size="small"
                        onClick={() => handleSave(key)}
                        sx={{ textTransform: 'none' }}
                      >
                        Save
                      </Button>
                      <Button
                        startIcon={<CancelIcon />}
                        variant="outlined"
                        size="small"
                        onClick={handleCancel}
                        sx={{ textTransform: 'none' }}
                      >
                        Cancel
                      </Button>
                      {messages[key] !== messages[key] && (
                        <Button
                          startIcon={<RestoreIcon />}
                          variant="outlined"
                          color="warning"
                          size="small"
                          onClick={() => handleReset(key)}
                          sx={{ textTransform: 'none' }}
                        >
                          Reset to Default
                        </Button>
                      )}
                    </Stack>
                  </Box>
                ) : (
                  <Box>
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 2,
                        mb: 2,
                        backgroundColor: '#f8f9fa',
                        fontFamily: 'monospace',
                        fontSize: '0.9rem',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                        maxHeight: 300,
                        overflow: 'auto',
                      }}
                    >
                      {value}
                    </Paper>
                    <Stack direction="row" spacing={1}>
                      <Button
                        startIcon={<EditIcon />}
                        variant="contained"
                        size="small"
                        onClick={() => handleEdit(key)}
                        sx={{ textTransform: 'none' }}
                      >
                        Edit Message
                      </Button>
                      {messages[key] !== messages[key] && (
                        <Button
                          startIcon={<RestoreIcon />}
                          variant="outlined"
                          color="warning"
                          size="small"
                          onClick={() => handleReset(key)}
                          sx={{ textTransform: 'none' }}
                        >
                          Reset to Default
                        </Button>
                      )}
                    </Stack>
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </Stack>

        {/* Info Section */}
        <Paper
          elevation={0}
          sx={{
            p: 2,
            mt: 3,
            backgroundColor: 'white',
            borderRadius: 2,
            border: '1px solid #e0e0e0',
          }}
        >
          <Typography variant="caption" color="text.secondary">
            💡 Tip: Click on any message to expand and edit its content. Use "Save All Changes" to apply your modifications.
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
};

export default OverViewPrompt;